document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const prevButton = gallery.querySelector('.custom-prev');
    const nextButton = gallery.querySelector('.custom-next');
    const slides = gallery.querySelectorAll('[data-media-id]');
    let currentIndex = 0;

    const showSlide = (index) => {
      const targetThumbnail = gallery.querySelectorAll('[data-target]')[index];
      if (targetThumbnail) {
        targetThumbnail.querySelector('button').click(); // triggers existing setActiveMedia
      }
    };

    prevButton?.addEventListener('click', () => {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(currentIndex);
    });

    nextButton?.addEventListener('click', () => {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    });

    // Optional: initialize currentIndex based on active slide
    slides.forEach((slide, i) => {
      if (slide.classList.contains('is-active')) currentIndex = i;
    });
  });
});
